import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import './SkeletonLoader.css';

export const SkeletonCard = () => (
  <Card className="skeleton-card h-100">
    <div className="skeleton skeleton-image"></div>
    <Card.Body>
      <div className="skeleton skeleton-badge mb-2"></div>
      <div className="skeleton skeleton-title mb-2"></div>
      <div className="skeleton skeleton-text mb-2"></div>
      <div className="skeleton skeleton-text" style={{ width: '80%' }}></div>
      <div className="skeleton-footer mt-3">
        <div className="skeleton skeleton-tag"></div>
        <div className="skeleton skeleton-tag"></div>
        <div className="skeleton skeleton-tag"></div>
      </div>
    </Card.Body>
  </Card>
);

export const SkeletonTripCard = () => (
  <Card className="skeleton-card trip-card h-100">
    <div className="skeleton skeleton-image" style={{ height: '200px' }}></div>
    <Card.Body>
      <div className="skeleton skeleton-title mb-2"></div>
      <div className="skeleton skeleton-text mb-3" style={{ width: '60%' }}></div>
      <div className="skeleton skeleton-text mb-2"></div>
      <div className="skeleton skeleton-text" style={{ width: '70%' }}></div>
      <div className="skeleton-footer mt-3 d-flex justify-content-between">
        <div className="skeleton skeleton-price"></div>
        <div className="skeleton skeleton-badge"></div>
      </div>
    </Card.Body>
  </Card>
);

export const SkeletonArticleCard = () => (
  <Card className="skeleton-card article-card h-100">
    <div className="skeleton skeleton-image" style={{ height: '180px' }}></div>
    <Card.Body>
      <div className="skeleton skeleton-badge mb-2" style={{ width: '80px' }}></div>
      <div className="skeleton skeleton-title mb-2"></div>
      <div className="skeleton skeleton-text mb-2"></div>
      <div className="skeleton skeleton-text" style={{ width: '90%' }}></div>
      <div className="skeleton-footer mt-3 d-flex justify-content-between">
        <div className="skeleton skeleton-tag"></div>
        <div className="skeleton skeleton-tag"></div>
      </div>
    </Card.Body>
  </Card>
);

export const SkeletonGrid = ({ count = 6, type = 'card' }) => {
  const SkeletonComponent = 
    type === 'trip' ? SkeletonTripCard : 
    type === 'article' ? SkeletonArticleCard : 
    SkeletonCard;

  return (
    <Row>
      {Array.from({ length: count }).map((_, index) => (
        <Col key={index} md={6} lg={4} className="mb-4">
          <SkeletonComponent />
        </Col>
      ))}
    </Row>
  );
};

export default SkeletonCard;
